import getCurrentReduxSelector from 'modules/redux/selectors/get-current'
import { TRAINING_USERS_PATH } from 'modules/training/modules/training-users/constants'

const getCurrentTrainingUserSelect = getCurrentReduxSelector(
  TRAINING_USERS_PATH.DATA,
  TRAINING_USERS_PATH.CURRENT
)

export default getCurrentTrainingUserSelect
